export default (props, { colors, rhythm, scale, treatments }) => {
  return {
    header: {
      display: 'flex',
      alignItem: 'baseline',
      justifyContent: 'space-between',
      marginBottom: rhythm(1)
    },
    title: {
      fontWeight: 'bold',
      small: {
        marginLeft: rhythm(0.5),
        fontSize: '75%',
        opacity: 0.5
      }
    },
    button: {
      ...treatments.head,
      fontSize: scale(-1),
      padding: 0
    },
    columns: {
      display: 'flex',
      flexWrap: 'wrap',
      fieldset: {
        flex: '50%',
        margin: rhythm([0.5, 0]),
        paddingRight: '2rem'
      }
    },
    input: {
      root: {
        marginBottom: rhythm(0.25)
      },
      label: {
        fontWeight: 'normal'
      }
    },
    status: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      background: 'white',
      padding: rhythm(1.5),
      transform: 'translate(-50%, -50%)',
      textAlign: 'center',
      boxShadow: '0 0 0 100rem rgba(0,0,0,0.25), 0 0 1rem rgba(0,0,0,0.25)',
      width: 'calc(100% - 3rem)',
      maxWidth: rhythm(22)
    },
    progress: {
      root: {
        margin: rhythm([0, 1]),
        height: rhythm(0.75)
      }
    }
  }
}
